import React from 'react'
import './index.css'

import DateTimePicker from './DateTimePicker'
import withInputDateTimeHandler from './withInputDateTimeHandler'
import { withModalBuilder } from '../modal/withModalBuilder'
import { withModal } from '../modal/withModal'
import { compose } from 'redux'

class DateTimePickerModal extends React.Component {
  handleConfirm = () => {
    this.props.onConfirm()
    this.props.onClose()
  }

  handleSave = value => {
    if (this.props.onSave) {
      this.props.onSave(value)
    }
    this.props.onClose()
  }

  render() {
    return (
      <DateTimePicker
        {...this.props}
        onClick={this.handleConfirm}
        onSave={this.handleSave}
      />
    )
  }
}

const withDateTimePicker = WrappedComponent => {
  return compose(
    withInputDateTimeHandler,
    withModal(DatePickerModalContainer, {
      props: ownProps => ownProps,
    }),
  )(WrappedComponent)
}

export default withDateTimePicker

export const DatePickerModalContainer = withModalBuilder({ isStatic: false })(
  DateTimePickerModal,
)



// WEBPACK FOOTER //
// ./src/modules/calendar/withDateTimePicker.js